import canClientUseCookieTokenStorage from '@/features/auth/functions/canClientUseCookieTokenStorage';
import useFeatureFlags from '@/features/feature-flags/hooks/useFeatureFlags';

/**
 * Check if the system is already migrated to cookie token storage and
 * client is already migrated to the new cookie storage
 *
 * @returns
 */
export default function useCanClientUseCookieTokenStorage() {
  const featureFlags = useFeatureFlags();
  return (
    featureFlags.auth.useCookieTokenStorage === true &&
    canClientUseCookieTokenStorage()
  );
}
